import React from 'react';
import { Card } from '../UI/Card';
import { Building, GraduationCap, Presentation, Award, Handshake, Tent } from 'lucide-react';
export const TrainingFormats = () => {
  const formats = [{
    title: 'Corporate Workshops',
    icon: <Building className="w-8 h-8 text-primary" data-id="element-1204" data-mp="lfkk5u3z16mi" />,
    description: 'Intensive, focused sessions designed to solve specific organizational challenges.'
  }, {
    title: 'Bootcamps',
    icon: <GraduationCap className="w-8 h-8 text-primary" data-id="element-1205" data-mp="cee3nl1bnvt9" />,
    description: 'Multi-day immersive learning experiences for rapid skill acquisition.'
  }, {
    title: 'Masterclasses',
    icon: <Presentation className="w-8 h-8 text-primary" data-id="element-1206" data-mp="2i196kxyddxg" />,
    description: 'Expert-led deep dives into specialized topics for advanced professionals.'
  }, {
    title: 'Certification Programs',
    icon: <Award className="w-8 h-8 text-primary" data-id="element-1207" data-mp="1wv0sop5gesa0" />,
    description: 'Structured curricula culminating in recognized credentials.'
  }, {
    title: 'Institutional Partnerships',
    icon: <Handshake className="w-8 h-8 text-primary" data-id="element-1208" data-mp="2yv7tqbw1ltiy" />,
    description: 'Long-term collaborative learning frameworks for schools and organizations.'
  }, {
    title: 'Retreat Trainings',
    icon: <Tent className="w-8 h-8 text-primary" data-id="element-1209" data-mp="38lasyttrc3pq" />,
    description: 'Off-site immersive experiences blending team building with capacity development.'
  }];
  return <section className="py-20 bg-white" data-id="element-1210" data-mp="33mpuozy2fu3x">
      <div className="container mx-auto px-4" data-id="element-1211" data-mp="2fwlsmx0j02f1">
        <div className="text-center mb-16 scroll-animate" data-id="element-1212" data-mp="2fxeqf8hibhl1">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1213" data-mp="2axsc0vpxzvan">
            Flexible Learning Formats
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1214" data-mp="2oy32hxncb7va">
            We deliver our programs in ways that best suit your team's needs and
            operational realities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1215" data-mp="45hro1ucn7gs">
          {formats.map((format, index) => <Card key={index} className="scroll-animate hover-lift border-2 border-gray-100 hover:border-primary/20" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-1216" data-mp="7k0wukxkdba" data-mpi={index}>
              {format.icon}
              <h3 className="mt-4 text-xl font-semibold" data-id="element-1217" data-mp="32y5h7vah5f4q">{format.title}</h3>
              <p className="mt-2 text-gray-600" data-id="element-1218" data-mp="32ywys278lcc0">{format.description}</p>
              <div className="flex flex-col items-center text-center p-4" data-id="element-1219" data-mp="36yfm14mj5zi0">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6" data-id="element-1220" data-mp="2a9ztr0s1dc17">
                  {format.icon}
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1221" data-mp="2f66rw7e6xj8l">
                  {format.title}
                </h3>
                <p className="text-gray-600" data-id="element-1222" data-mp="2o0mj42bwppkm">{format.description}</p>
              </div>
            </Card>)}
        </div>

        <div className="max-w-3xl mx-auto bg-navy text-white rounded-2xl p-8 md:p-12 text-center scroll-animate" data-id="element-1223" data-mp="1rjrxn2mr7lui">
          <h3 className="text-2xl font-bold mb-6" data-id="element-1224" data-mp="1vjiloykwbnvc">Delivery Modes</h3>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8" data-id="element-1225" data-mp="1o0svsqhoulmf">
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full w-full md:w-auto justify-center" data-id="element-1226" data-mp="1j27u0mmsftvv">
              <span className="w-3 h-3 rounded-full bg-green-400" data-id="element-1227" data-mp="1ezbex5wgifwo"></span>
              <span className="font-medium text-lg" data-id="element-1228" data-mp="1a1jmmarwgrry">On-site</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full w-full md:w-auto justify-center" data-id="element-1229" data-mp="1a3mez1giywzu">
              <span className="w-3 h-3 rounded-full bg-blue-400" data-id="element-1230" data-mp="10ayhe4hq0p02"></span>
              <span className="font-medium text-lg" data-id="element-1231" data-mp="109nb9y0sz55s">Virtual</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full w-full md:w-auto justify-center" data-id="element-1232" data-mp="vcnaa1it8slj">
              <span className="w-3 h-3 rounded-full bg-purple-400" data-id="element-1233" data-mp="mbpc3zv1zfav"></span>
              <span className="font-medium text-lg" data-id="element-1234" data-mp="maxe6idzh5hf">Hybrid</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};